import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../../res/translations/messages';
import ShuffledChoiceType from '../ShuffledChoiceType';

const SingleChoice4Type = ({question}) => (
    <>
        <h4><FormattedMessage {...messages.surveys.form.label.optionList} /></h4>
        <ShuffledChoiceType choices={question.choices} />
    </>
);

SingleChoice4Type.propTypes = {
    question: PropTypes.object.isRequired,
};


export default SingleChoice4Type;
